import React, { useImperativeHandle, useRef } from 'react';
import clsx from 'clsx';
import { Grid } from '@mui/material';
import { Card, Typography, TextField, Stack, CheckboxField } from "@curves/ui-base";
import { PasswordToggle, ReadTextField } from '@icoach/components/';

const ConfigurationOthersFormContent = React.forwardRef((props, ref) => {
	const { className: classNameProps, sourceData } = props;
    const {
        billingBankName = '', billingMerchantNo = '',
        ecPaySetting = {}, smsSetting = {}
    } = sourceData;

	const ecPaySettingMerchantidRef = useRef(null);
	const ecPaySettingAccountRef = useRef(null);
	const ecPaySettingPasswordRef = useRef(null);
	const ecPaySettingHashkeyRef = useRef(null);
	const ecPaySettingHashivRef = useRef(null);
    const epPaySettingNotifyMixedRef = useRef(null)

	const smssettingAccountRef = useRef(null);
	const smssettingPasswordRef = useRef(null);
    

	// 綠界
	const getEcPaySettingParams = () => {
        console.log(epPaySettingNotifyMixedRef.current.getResult()[0].checked)
		let params = {
			...ecPaySetting,
			merchantID: ecPaySettingMerchantidRef.current.getResult(),
			account: ecPaySettingAccountRef.current.getResult(),
			hashKey: ecPaySettingHashkeyRef.current.getResult(),
			hashIV: ecPaySettingHashivRef.current.getResult(),
            notifyMixed: epPaySettingNotifyMixedRef.current.getResult()[0].checked
		};
		const password = ecPaySettingPasswordRef.current.getResult();
		if (password) {
			params.password = password;
		}
		return params;
	};

	// 三竹
	const getSmsSettingParams = () => {
		let params = {
			...smsSetting,
			account: smssettingAccountRef.current.getResult()
		};
		const password = smssettingPasswordRef.current.getResult();
		if (password) {
			params.password = password;
		}
		return params;
	};

	useImperativeHandle(
		ref,
		() => {
			return {
				getResult: () => {
					return {
						ecPaySetting: getEcPaySettingParams(),
						smsSetting: getSmsSettingParams()
					};
				},
				isDifference: () => {}
			};
		},
		// eslint-disable-next-line
		[]
	);

	return (
		<React.Fragment>
            <Card.CardContent className={clsx(classNameProps)}>
                <Typography className={'font-weight-medium'} variant={'h5'}>
                    批次扣款設定
                </Typography>
                <Grid container spacing={3}>
                    <Grid item xs={4}>
                        <ReadTextField label={'銀行'}>{billingBankName}</ReadTextField>
                    </Grid>
                    <Grid item xs={4}>
                        <ReadTextField label={'特店代號'}>{billingMerchantNo}</ReadTextField>
                    </Grid>
                </Grid>
            </Card.CardContent>
			<Card.CardContent className={clsx(classNameProps)}>
				<Typography variant="h4" component={'h3'} className="mb-2">
					電子發票設定
				</Typography>
				<Grid container spacing={3}>
					<Grid item xs={4}>
						<TextField ref={ecPaySettingMerchantidRef} label={'商店代號'} defaultValue={ecPaySetting.merchantID} fullWidth />
					</Grid>
					<Grid item xs={4}>
						<TextField ref={ecPaySettingAccountRef} label={'帳號'} defaultValue={ecPaySetting.account} fullWidth />
					</Grid>
					<Grid item xs={4}>
						<PasswordToggle
							ref={ecPaySettingPasswordRef}
							label="密碼"
							inputProps={{
								placeholder: ecPaySetting.password
							}}
						/>
					</Grid>
					<Grid item xs={4}>
						<TextField ref={ecPaySettingHashkeyRef} label={'HashKey'} defaultValue={ecPaySetting.hashKey} fullWidth />
					</Grid>
					<Grid item xs={4}>
						<TextField ref={ecPaySettingHashivRef} label={'HashIV'} defaultValue={ecPaySetting.hashIV} fullWidth />
					</Grid>
                    <Grid item xs={12}>
                        <Stack direction={'column'} className="bg-info-light px-4 py-2 mb-4">
                            <CheckboxField ref={epPaySettingNotifyMixedRef} defaultValue={[ecPaySetting.notifyMixed]}>
                                <CheckboxField.Checkbox value={true} label={'已設定發票開立通知為混合模式(電子郵件及手機簡訊)'} />
                            </CheckboxField>
                        </Stack>
                    </Grid>
				</Grid>
			</Card.CardContent>
			<Card.CardContent className={clsx(classNameProps)}>
				<Typography variant="h4" component={'h3'} className="mb-2">
					簡訊發送設定
				</Typography>
				<Grid container spacing={3}>
					<Grid item xs={4}>
						<TextField ref={smssettingAccountRef} label={'帳號'} defaultValue={smsSetting.account} fullWidth />
					</Grid>
					<Grid item xs={4}>
						<PasswordToggle
							ref={smssettingPasswordRef}
							label="密碼"
							inputProps={{
								placeholder: smsSetting.password
							}}
						/>
					</Grid>
				</Grid>
			</Card.CardContent>
		</React.Fragment>
	);
});

export default ConfigurationOthersFormContent;
